export default "__VITE_ASSET__BF__7Eu$__"